import { render, staticRenderFns } from "./pi-card.vue?vue&type=template&id=56b4538e&"
import script from "./pi-card.vue?vue&type=script&lang=js&"
export * from "./pi-card.vue?vue&type=script&lang=js&"
import style0 from "./pi-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports